import { createAsyncSagaAction } from 'utils/reduxUtils';
import * as actionTypes from './actionTypes';

export const getContactPaths = createAsyncSagaAction(actionTypes.GET_CONTACT_PATHS);
export const getProfileInit = createAsyncSagaAction(actionTypes.GET_PROFILE_INIT);
export const hasSendNotificationPermission = createAsyncSagaAction(actionTypes.HAS_SEND_NOTIFICATION_PERMISSION);
export const recaptchaVerified = createAsyncSagaAction(actionTypes.RECAPTCHA_VERIFIED);
export const sendTestNotification = createAsyncSagaAction(actionTypes.SEND_TEST_NOTIFICATION);
